<template>
    <g>
        <path :style="{ fill: color }" d="M56.6,60.1c-0.9-0.3-2.3,0-2.8,0.2c-0.6-0.1-1.7-0.5-2.7-0.2c-0.8,0.3-2.8,1.8-3.3,2.2c0,0,0,0,0,0
	c0.5,0.4,0.7,0.7,1,1.1c0.4,0.5,1,1.1,1.6,1.5c0.8,0.5,1.9,0.7,3.1,0.7c1.3,0.1,2.6-0.2,3.6-0.7c0.6-0.4,1.2-0.9,1.6-1.5
	c0.4-0.4,0.5-0.8,1-1.1c0,0,0,0,0,0C59.3,61.9,57.4,60.4,56.6,60.1z M54.1,62.8c-0.1,0-0.5,0-0.6,0c-1-0.2-2.3,0.1-3.2-0.3
	c0.6-0.4,1.9-0.4,2.4-0.4c0.7,0.1,1.4,0.1,2.1,0c0.5-0.1,1.8,0,2.4,0.4C56.4,62.9,55.1,62.6,54.1,62.8z"/>
    </g>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth13',
        mixins: [Mouth],
    }
</script>
